const COL_MAX = 7;
const ROW_MAX = 5;
const GRID_MAX = COL_MAX * ROW_MAX;
const GRID_SIZE = 120;

export { COL_MAX, ROW_MAX, GRID_SIZE, GRID_MAX };
